import React from 'react';

const CloseIcon24 = ({ className }) => (
  <svg className={className} height="24" width="24">
    <path d="m19 6.41-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z" />
  </svg>
);

export default CloseIcon24;
